module.exports = __webpack_public_path__ + "img/turkmenistan.af6a5675.svg";